export const criarUsuario = (nome, identificador, tipoIdentificador) => {
  return {
    nome,
    identificador,
    tipoIdentificador
  }
}
